export default "__VITE_ASSET__1c6a8b94__"